import {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'reactstrap'

export const availabilityChoices =  [
  {text: 'Tous'},
  {value: 0, text: 'Immédiate'},
  {value: 1, text: '1 mois'},
  {value: 2, text: '2 mois'},
  {value: 3, text: '3 mois'},
]

export default class Filter extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    value: '',
  }

  constructor(props) {
    super(props)
    this.choices = [
      {value: '', text: 'Tous'},
      {value: 0, text: 'Immédiate'},
      {value: 1, text: '1 mois max'},
      {value: 2, text: '2 mois max'},
      {value: 3, text: '3 mois max'},
    ]
  }

  onChange = (event) => {
    const value = event.target.value
    this.props.onChange(value === '' ? undefined : parseInt(value, 10))
  }

  render() {
    const value = (this.props.value === undefined || this.props.value === null || isNaN(this.props.value))
      ? ''
      : this.props.value

    return (
      <Input type="select" value={value} onChange={this.onChange}>
        {this.choices.map((choice) => (
          <option value={choice.value} key={choice.value}>{choice.text}</option>
        ))}
      </Input>
    )
  }
}
